import React from 'react'
import { Document, Page, Text, View, StyleSheet, PDFViewer } from "@react-pdf/renderer"

const styles = StyleSheet.create({
    page: {
        flexDirection: "column",
        backgroundColor: "#ffffff",
        padding: 30,
    },
    cell: {
        fontSize: 7,
        textAlign: "center",
        padding: "auto",
        borderLeftWidth: 1,
        paddingTop: 2,
    },
    headerCenter: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        marginVertical: 7,
    }
})

export default function DailyProductionReportPDF({ data, printDate }) {
    return (
        <div style={{ width: "100%", height: "100%" }}>
            <PDFViewer style={{ width: "100%", height: "100%" }}>
                <Document>
                    <Page size="A3" style={styles.page}>
                        <View style={{ width: "100%", borderWidth: 1, height: "100%" }}>
                            <View style={styles.headerCenter}>
                                <Text>PRECISION OVERSEAS</Text>
                            </View>
                            <View style={{ height: 0.7, backgroundColor: "#000000" }}></View>
                            <View style={styles.headerCenter}>
                                <Text>DAILY PRODUCTION REPORTS</Text>
                            </View>

                            {/* show date */}
                            <View style={{ display: "flex", justifyContent: "center", marginBottom: 6 }}>
                                <Text>Report Date: {printDate || ""}</Text>
                            </View>

                            <View style={{ display: "flex", flexDirection: "row", borderTopWidth: 1, borderBottomWidth: 1 }}>
                                <Text style={{ ...styles.cell, width: "5%" }}>Sn. No</Text>
                                <Text style={{ ...styles.cell, width: "10%" }}>Machine No</Text>
                                <Text style={{ ...styles.cell, width: "10%" }}>Card No</Text>
                                <Text style={{ ...styles.cell, width: "10%" }}>Operator Name</Text>
                                <Text style={{ ...styles.cell, width: "10%" }}>Cycle Time (pcs/min)</Text>
                                <Text style={{ ...styles.cell, width: "10%" }}>Count(8:30 AM)</Text>
                                <Text style={{ ...styles.cell, width: "10%" }}>Target(6:00 PM)</Text>
                                <Text style={{ ...styles.cell, width: "10%" }}>Actual Target(6:00 PM)</Text>
                                <Text style={{ ...styles.cell, width: "10%" }}>%</Text>
                                <Text style={{ ...styles.cell, width: "10%" }}>Start Time</Text>
                                <Text style={{ ...styles.cell, width: "10%" }}>Stop Time</Text>
                                <Text style={{ ...styles.cell, width: "10%" }}>Reason</Text>
                            </View>
                            {data.map((row, idx) => (
                                <View key={idx} style={{ display: "flex", flexDirection: "row", borderBottomWidth: 1 }}>
                                    <Text style={{ ...styles.cell, width: "5%" }}>{idx + 1}</Text>
                                    <Text style={{ ...styles.cell, width: "10%" }}>{row.machineNo}</Text>
                                    <Text style={{ ...styles.cell, width: "10%" }}>{row.partNo}</Text>
                                    <Text style={{ ...styles.cell, width: "10%" }}>{row.customOperatorName ?? row.operatorName}</Text>
                                    <Text style={{ ...styles.cell, width: "10%" }}>{row.cycleTime}</Text>
                                    <Text style={{ ...styles.cell, width: "10%" }}>{row.count}</Text>
                                    <Text style={{ ...styles.cell, width: "10%" }}>{row.target}</Text>
                                    <Text style={{ ...styles.cell, width: "10%" }}>{row.actualCount}</Text>
                                    <Text style={{ ...styles.cell, width: "10%" }}>{row.effeciencyPercent}%</Text>
                                    <Text style={{ ...styles.cell, width: "10%" }}>{row.startTime}</Text>
                                    <Text style={{ ...styles.cell, width: "10%" }}>{row.stopTime}</Text>
                                    <Text style={{ ...styles.cell, width: "10%" }}>{row.description}</Text>
                                </View>
                            ))}
                        </View>
                    </Page>
                </Document>
            </PDFViewer>
        </div>
    )
}
